import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-preview-search",
  "use": "icon-preview-search-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-preview-search\">\n<circle cx=\"11\" cy=\"7\" r=\"6\" stroke=\"currentColor\" stroke-width=\"2\" />\n<rect x=\"5.30371\" y=\"10.6465\" width=\"2\" height=\"7.50061\" rx=\"1\" transform=\"rotate(45 5.30371 10.6465)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol